import settings from '../data/settings';
import store from '../store';

import { BejegyzesStoreTypes } from '../store/modules/bejegyzes';

import { AppStoreTypes } from '../store/modules/app';
import { Languages } from '../data/enums/kodszotar/languages';

class ApiService {
  /**
   *
   * @param {import('../mock/mockHttpContext').HttpContext} http
   */

  constructor(http) {
    this.http = http;
  }
  async GetAllTranslations({ mock = true } = {}) {
    var url = settings.baseUrl + 'Api/Translation/GetAllTranslations';
    let result = await this.http.post({ url, mock });
    return result;
  }
  async GetGarbagePlaces({ mock = true } = {}) {
    var url = settings.baseUrl + 'Api/GarbagePlaces/GetGarbagePlaces';
    let countryResourceKey = store.getters[AppStoreTypes.selectedCountry.get];
    if (countryResourceKey.ResourceKey == Languages.All) {
      console.log(countryResourceKey.ResourceKey + ' - ' + Languages.All);
      countryResourceKey = '';
    }
    let data = { countryResourceKey: countryResourceKey.ResourceKey };
    let response = await this.http.post({ url, data, mock });
    store.dispatch(BejegyzesStoreTypes.bejegyzesek.set, {
      value: response,
    });
    return response;
  }
  async GetAppData({ mock = true } = {}) {
    var url = settings.baseUrl + 'Api/Home/GetAppData';

    let response = await this.http.post({ url, mock });
    store.dispatch(AppStoreTypes.countries.set, {
      value: response.countries,
    });
    return response;
  }
}

export default ApiService;
